import BasicLayout from '@/layouts/basic-layout'

const prefix = 'accounts-lease-withdrawal-statement-'
export default {
  path: '/report-center/accounts-lease-withdrawal-statement',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '退租报表'},
      component: () => import('@/pages/report-center/accounts-lease-withdrawal-statement/index')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {title: '退租报表编辑'},
      component: () => import('@/pages/report-center/accounts-lease-withdrawal-statement/detail-edit')
    },
    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '退租报表详情'},
      component: () => import('@/pages/report-center/accounts-lease-withdrawal-statement/detail-view')
    }
  ]
}
